import { createPaginatedSlice } from "../../../helpers/reduxHelper";

const configuratorLightingPopup = createPaginatedSlice('configuratorLightingPopup');

export const configuratorLightingPopupActions = configuratorLightingPopup.actions
export const configuratorLightingPopupSelector = state => state.configuratorLightingPopup;
export const configuratorLightingPopupReducer = configuratorLightingPopup.reducer;
export default configuratorLightingPopupReducer

export const configuratorLightingPopupSelectors = configuratorLightingPopup.LF.selectors